"use strict";

exports.__esModule = true;
exports.TYPE_OPTIONS = exports.TOKENS = exports.INPUTMODE = void 0;
let TYPE_OPTIONS = exports.TYPE_OPTIONS = /*#__PURE__*/function (TYPE_OPTIONS) {
  TYPE_OPTIONS["TEXT"] = "text";
  TYPE_OPTIONS["NUMBER"] = "number";
  TYPE_OPTIONS["EMAIL"] = "email";
  TYPE_OPTIONS["PASSWORD"] = "password";
  TYPE_OPTIONS["PASSPORTID"] = "passportid";
  return TYPE_OPTIONS;
}({});
let TOKENS = exports.TOKENS = /*#__PURE__*/function (TOKENS) {
  TOKENS["heightInput"] = "heightInput";
  TOKENS["fontSizeInput"] = "fontSizeInput";
  TOKENS["paddingInput"] = "paddingInput";
  TOKENS["iconSize"] = "iconSize";
  return TOKENS;
}({});
let INPUTMODE = exports.INPUTMODE = /*#__PURE__*/function (INPUTMODE) {
  INPUTMODE["NUMERIC"] = "numeric";
  INPUTMODE["TEL"] = "tel";
  INPUTMODE["DECIMAL"] = "decimal";
  INPUTMODE["EMAIL"] = "email";
  INPUTMODE["URL"] = "url";
  INPUTMODE["SEARCH"] = "search";
  INPUTMODE["TEXT"] = "text";
  INPUTMODE["NONE"] = "none";
  return INPUTMODE;
}({});